import React, {Component} from 'react';
import './update.sass';
import FirebaseContext from "../../Firebase/context";
import Loader from "../../commons/Loader/loader";
import {Table, Icon, Input, Button,} from 'antd';
import Modal from "../../../components/commons/Modal/index";
import UpdateModal from "../../commons/UpdateModal/update_modal";
import Highlighter from 'react-highlight-words';


class Update extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            updateFile: null,
            loading: false,
            searchText: "",
            document: '',
            modal: {
                showModal: false,
                title: '',
                body: '',
                showButtons: false
            },
            showUpdateModal: false,
            columns: [
                {
                    title: 'Nome',
                    dataIndex: 'name',
                    key: 'name',
                    width: '18%',
                    ...this.getColumnSearchProps('name'),
                },
                {
                    title: 'Descrizione',
                    dataIndex: 'description',
                    key: 'description',
                    width: '37%'
                },
                {
                    title: 'Sotto Categoria',
                    key: 'subCategoryName',
                    dataIndex: 'subCategoryName',
                    width: '20%',
                    ...this.getColumnSearchProps('subCategoryName'),
                },
                {
                    title: 'PDF',
                    dataIndex: 'pdfName',
                    width: '25%',
                    editable: true,
                    render: (text, row) => {
                        return <a target="_blank" href={row.pdfUrl}>{text}</a>;
                    }
                },
                {
                    title: 'Azione',
                    key: 'action',
                    fixed: 'right',
                    render: (document, record) => (
                        <span >
                            <Icon className="action iconEdit"  onClick={this.editModal.bind(this, document)} type="edit"
                                  title="modifica"/>
                            <Icon className="action iconDelete" theme="filled" onClick={this.deleteItem.bind(this, document)}
                                  type="delete" title="elimina"/>
                    </span>
                    ),
                },
            ]
        };
    }

    componentDidMount() {
        this.getProduct();
    }


    getProduct() {
        let prod = [];
        this.setState({loading: true});
        this.props.props.firebase.db.collection("products").get().then((product) => {
            product.forEach((doc) => {
                let document = doc.data();
                document.idDocument = doc.id;
                prod.push(document);
            });
            this.deferSubCat(prod);
        }).catch(error => {
            this.showModal('ERROR', 'Si è verificato un errore. Riprova più tardi!', false);
            console.log(error)
        });
    }

    deferSubCat(prod) {
        prod.map(async (item) => {
            this.props.props.firebase.db.collection("subCategories").doc(item.subCategoryId).get().then((doc) => {
                item.subCategoryName = doc.data().name;
            });
        });
        setTimeout(function () {
            this.setState({data: prod, loading: false});
        }.bind(this), 1000)
    }


    //apertura modale
    showModal = (title, body, button) => {
        this.setState((prevState) => ({
            ...prevState, modal: {
                ...prevState.modal,
                showModal: true, title: title, body: body, showButtons: button
            }
        }));

    }


    //chiusura modale
    closeModal = () => {
        this.setState((prevState) => ({...prevState, modal: {...prevState.modal, showModal: false}}));

    }

    confirmDelete() {
        let id = this.state.document.idDocument;
        this.setState({loading: true});
        this.closeModal();
        this.props.props.firebase.db.collection("products").doc(id).delete().then(success => {
            this.setState({loading: false});
            this.showModal('Success', 'Operazione avvenuta con successo!', false);
            this.getProduct();
        }).catch(error => {
            this.setState({loading: false});
            this.showModal('Error', 'Si è verificato un errore. Riprova più tardi!', false);
            alert(error)
        });
    }

    deleteItem(document) {
        this.showModal('Attenzione', 'Sei sicuro di voler eliminare il prodotto?', true);
        this.setState({document: document})

    }

    cancelDelete() {
        this.setState({document: ''})
        this.closeModal();
    }


    //edit product

    editModal(document) {
        this.setState({showUpdateModal: true, document: document})

    }

    documentChange(e) {
        const {name, value} = e.target;
        this.setState((prevState) => ({...prevState, document: {...prevState.document, [name]: value}}));
    }

    updatePdf(e) {
        if (e.target.files.length > 0) {
            let file = e.target.files[0];
            this.setState({updateFile: file})
            this.setState((prevState) => ({
                ...prevState,
                document: {...prevState.document, pdfName: file.name}
            }));
        }
    }

    startEditSubmit(e) {
        e.preventDefault();
        this.setState({loading: true});
        if (this.state.updateFile !== null && this.state.updateFile !== undefined) {
            const file = this.state.updateFile;
            const storeageRef = this.props.props.firebase.sto.ref("products");
            const mainImage = storeageRef.child(file.name);
            mainImage.getDownloadURL().then(url => {
                this.setState({loading: false});
                this.showModal('Attenzione', 'Il nome del pdf è già esistente! Ti preghiamo di modificare il nome del file e riprovare. Grazie!');
            }).catch(error => {
                mainImage.put(file).then((result) => {
                    mainImage.getDownloadURL().then((url) => {
                        this.setState((prevState) => ({
                            ...prevState,
                            document: {...prevState.document, pdfName: file.name, pdfUrl: url}
                        }));
                        this.saveEditModal(e);
                    }).catch(error => {
                        this.showModal('ERROR', 'Si è verificato un errore. Riprova più tardi!');
                        console.log("pdf " + error)
                    })
                })
            });
        } else {
            this.saveEditModal(e);
        }
    }

    saveEditModal(e) {
        const {document} = this.state;
        if (document.name.trim() !== '' || document.description.trim() !== '') {
            this.props.props.firebase.db.collection("products").doc(document.idDocument).update(document).then(result => {
                this.getProduct();
                this.setState({showUpdateModal: false, loading: false})
                this.showModal('Success', 'Operazione avvenuta con successo!');
                console.log("add " + result)
            }).catch(error => {
                this.showModal('ERROR', 'Si è verificato un errore. Riprova più tardi!');
                this.setState({showUpdateModal: false, loading: false});
                console.log("add " + error)
            });
        }
    }

    closeEditModal(e) {
        this.setState({showUpdateModal: false, document: ''})
    }




    //search
    getColumnSearchProps = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={node => {
                        this.searchInput = node;
                    }}
                    placeholder={`Cerca ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Button
                    type="primary"
                    onClick={() => this.handleSearch(selectedKeys, confirm)}
                    icon="search"
                    size="small"
                    style={{ width: 90, marginRight: 8 }}>
                    Cerca
                </Button>
                <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90,  marginLeft: 8 }}>
                    Reset
                </Button>
            </div>
        ),
        filterIcon: filtered => (
            <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        onFilter: (value, record) =>
            record[dataIndex]
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
        onFilterDropdownVisibleChange: visible => {
            if (visible) {
                setTimeout(() => this.searchInput.select());
            }
        },
        render: text => (
            <Highlighter
                highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                searchWords={[this.state.searchText]}
                autoEscape
                textToHighlight={text.toString()}
            />
        ),
    });

    handleSearch = (selectedKeys, confirm) => {
        confirm();
        this.setState({ searchText: selectedKeys[0] });
    };

    handleReset = clearFilters => {
        clearFilters();
        this.setState({ searchText: '' });
    };

    render() {
        const {state} = this.props;

        return (
            <div>
                <div className="update">
                    <Table columns={this.state.columns}  dataSource={this.state.data} scroll={{x: '80%'}}/>

                </div>

                {this.state.modal.showModal &&
                <Modal modal={this.state.modal} closeModal={this.closeModal.bind(this)}
                       cancel={this.cancelDelete.bind(this)} confirm={this.confirmDelete.bind(this)}/>}

                {this.state.showUpdateModal &&
                <UpdateModal state={this.state} props={this.props.props} document={this.state.document}
                             documentChange={this.documentChange.bind(this)} updatePdf={this.updatePdf.bind(this)}
                             closeEditModal={this.closeEditModal.bind(this)}
                             startEditSubmit={this.startEditSubmit.bind(this)}/>}

                {this.state.loading && <Loader/>}
            </div>
        )
    }
}

Update.contextType = FirebaseContext;

export default Update;



